
import { observer } from 'mobx-react-lite'

// evertel
import { useService } from '@evertel/di'
import { SessionService } from '@evertel/session/SessionService'
import { DrawerNavItemLink } from '../elements'

interface DrawerProps {
    tag?: string
}


const AccountDrawer: React.FC<DrawerProps> = observer(() => {

    const sessionService = useService(SessionService, [])

    return (
        <>
            <DrawerNavItemLink
                label="My Profile"
                icon={{ name: 'user' }}
                to={`/account/profile/${sessionService.currentUserId}`}
                selectedTo="/account/profile"
            />
            <DrawerNavItemLink
                label="Preferences"
                icon={{ name: 'sliders-h' }}
                to="/account/preferences"
            />
            <DrawerNavItemLink
                label="Security"
                icon={{ name: 'lock' }}
                to="/account/security"
            />
            <DrawerNavItemLink
                label="Notifications"
                icon={{ name: 'bell' }}
                to="/account/notifications"
            />
            <DrawerNavItemLink
                label="My Agencies"
                icon={{ name: 'list-alt' }}
                to="/account/departments"
                selectedTo="/account/departments"
            />
            <DrawerNavItemLink
                label="My Agreements"
                icon={{ name: 'file-contract' }}
                to="/account/agreements"
                selectedTo="/account/agreements"
            />
        </>
    )
})

export { AccountDrawer }

